import { ENV } from '@env';

export const isProduction = (): boolean => {
  return ENV === 'LIVE';
};

export default isProduction;
